import {
  Bridge,
  BridgeAction,
  BridgePayload,
  BridgePayloadMap,
} from "./Bridge";
import { Logger } from "../utils/Logger";

export class IosBridge extends Bridge {
  readonly platform = "ios";

  protected postMessage(action: BridgeAction, payload?: BridgePayload) {
    if (typeof window === "undefined") {
      Logger.error("window is undefined", {
        tags: { from: "IosBridge.postMessage" },
      });
      return;
    }

    const handler = window.webkit?.messageHandlers?.Blux;
    if (!handler?.postMessage) {
      Logger.error("No iOS WKWebView Blux handler available", {
        tags: { from: "IosBridge.postMessage" },
      });
      return;
    }

    handler.postMessage(JSON.stringify({ action, payload }));
  }

  initialize(payload: BridgePayloadMap["initialize"]) {
    this.postMessage("initialize", payload);
  }

  signIn(payload: BridgePayloadMap["signIn"]) {
    this.postMessage("signIn", payload);
  }

  signOut() {
    this.postMessage("signOut");
  }

  setUserProperties(payload: BridgePayloadMap["setUserProperties"]) {
    this.postMessage("setUserProperties", payload);
  }

  setCustomUserProperties(
    payload: BridgePayloadMap["setCustomUserProperties"],
  ) {
    this.postMessage("setCustomUserProperties", payload);
  }

  sendEvent(payload: BridgePayloadMap["sendEvent"]) {
    this.postMessage("sendEvent", payload);
  }
}
